module.exports = __webpack_public_path__ + "img/dexi-sim.c625ac92.png";